// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__gXSO9","image":"styles_image__B-Hmi","menuWrapper":"styles_menuWrapper__l-bBV","isRtl":"styles_isRtl__pgh9h"};